export default __webpack_public_path__ + "static/media/EAST1060.34I-34184_-18431_0.231d6c4c.jpg";